import customizeValidator from './customizeValidator';

export { customizeValidator };
export * from './types';

/** @deprecated in favor of the `@rjsf/validator-ajv8
 */
export default customizeValidator();
